import { useState } from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { Icon } from '@iconify/react';

import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';

import { editItem, getItem, deleteItemWithBody } from '../../fetch';
import { useEffectAsync } from '../../reactHelper';
import { useTranslation } from '../../common/LocalizationProvider';
import { PermissionDialog } from '../permission';
import { selectGeofencesArray } from '../../createSelectorUtils';

DeviceLinkedGeofence.propTypes = {
  deviceId: PropTypes.number.isRequired
};
export default function DeviceLinkedGeofence({ deviceId }) {
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const allGeofence = useSelector(selectGeofencesArray);
  const [linkedGeofence, setLinkedGeofence] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffectAsync(async () => {
    if (isOpen) {
      const response = await getItem(`geofences?deviceId=${deviceId}`);
      if (response.ok) {
        setLinkedGeofence(await response.json());
      }
    }
  }, [isOpen]);

  const handleChange = async (event) => {
    const newGeofence = allGeofence.find((item) => item.id === parseInt(event.target.value, 10));
    if (newGeofence) {
      const create = !linkedGeofence.map((item) => item.id).includes(newGeofence.id);
      const response = create
        ? await editItem('permissions', undefined, {
            deviceId,
            geofenceId: newGeofence.id
          })
        : await deleteItemWithBody('permissions', {
            deviceId,
            geofenceId: newGeofence.id
          });
      if (response.ok) {
        setLinkedGeofence(
          create
            ? [...linkedGeofence, newGeofence]
            : linkedGeofence.filter((item) => item.id !== newGeofence.id)
        );
      } else {
        const error = await response.text();
        const message = error.slice(0, error.indexOf('-'));
        enqueueSnackbar(message, { variant: 'error' });
      }
    }
  };

  return (
    <>
      <MenuItem sx={{ color: 'text.secondary' }} onClick={() => setIsOpen(true)}>
        <ListItemIcon>
          <Icon icon="material-symbols:activity-zone" width={24} height={24} />
        </ListItemIcon>
        <ListItemText
          primary={t('UL_Menu_Linked_Geofence')}
          primaryTypographyProps={{ variant: 'body2' }}
        />
      </MenuItem>

      <PermissionDialog
        title="UL_Menu_Linked_Geofence"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        handleChange={handleChange}
        allObject={allGeofence}
        linkedObject={linkedGeofence}
      />
    </>
  );
}
